import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.3335 5.91665V14.6666C3.3335 16.0474 4.45278 17.1666 5.8335 17.1666H15.0002C15.9206 17.1666 16.6668 16.4205 16.6668 15.5V9.66665C16.6668 8.74617 15.9206 7.99998 15.0002 7.99998H13.3335M3.3335 5.91665C3.3335 7.06724 4.26624 7.99998 5.41683 7.99998H13.3335M3.3335 5.91665C3.3335 4.76605 4.26624 3.83331 5.41683 3.83331H12.157C12.8068 3.83331 13.3335 4.36004 13.3335 5.00978V7.99998",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.917 11.7917C13.3541 11.7919 13.708 12.1466 13.708 12.5837C13.7078 13.0206 13.354 13.3745 12.917 13.3747C12.4799 13.3747 12.1252 13.0208 12.125 12.5837C12.125 12.1465 12.4798 11.7917 12.917 11.7917Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.75"
    }, null, -1)
  ]))]))
}
export default { render: render }